
import { useEffect, useRef, useState } from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { Modal } from 'reactstrap';
import CollapsibleUI from '../Collapsible';
import './CustomSelect.css';

const CustomSelect = ({ categories, placeholder = "", selectedCategory, catName }) => {
    const inputRef = useRef();
    const ulRef = useRef();

    const [activeCategory, setActiveCategory] = useState(null);
    const [categoryName, setCategoryName] = useState(catName);
    const [isSelectCatModal, setIsSelectModal] = useState(false);


    useEffect(() => {
        setCategoryName(activeCategory?.category_name ?? catName);
        if (activeCategory !== null) {
            selectedCategory(activeCategory.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeCategory])

    useEffect(() => {

        inputRef.current.addEventListener('click', (event) => {
            event.stopPropagation();
            // ulRef.current.style.display = 'block';
            setIsSelectModal(true);
        });
        // ulRef.current.addEventListener('click', (event) => {
        //     event.stopPropagation();
        // });


        // document.getElementById('edit-modal').addEventListener('click', (event) => {
        //     try {
        //         // ulRef.current.style.display = 'none';
        //     }
        //     catch (e) {
        //         // console.log(e.message)
        //     }
        // });

        // ulRef.current.style.display = 'none';

    }, [ulRef, inputRef])

    return (
        <div className="align-items-center position-relative">

            <input ref={inputRef} className={`form-control`} type="search" placeholder={placeholder} value={categoryName ?? catName} onChange={(e) => { }} />

            {/* <div ref={ulRef} style={{ width: "100%", maxHeight: "40vh", overflow: "scroll", position: "absolute", background: "white", zIndex: 1001, top: "115%", border: "1px solid hsl(0, 0%, 80%)", borderRadius: "5px", padding: "8px", boxShadow: "0px 3px 10px 3px rgba(0,0,0,0.19)" }}>
                <>
                    {categories && <RenderCollapsible categories={categories} activeCategory={activeCategory} setActiveCategory={(cat) => setActiveCategory(cat)} />}

                </>
            </div> */}
            <Modal centered isOpen={isSelectCatModal} toggle={() => { setIsSelectModal(false); }}>
                <div onClick={() => { setIsSelectModal(false); }} className='position-absolute cursor-pointer' style={{ top: 6, right: 10 }}>
                    <FaTimes size={20} />
                </div>
                <div className='p-3'>
                    <div className='d-flex mb-2'>
                        <h4>Select Category: <span className='fs-5'>{activeCategory?.category_name}</span></h4>
                    </div>
                    {categories && <>
                        <RenderCollapsible categories={categories} activeCategory={activeCategory} setActiveCategory={(cat) => setActiveCategory(cat)} />
                        <button onClick={() => { setIsSelectModal(false); }} className='btn btn-sm btn-success'><FaCheck size={15} /> Done</button>
                    </>}
                </div>
            </Modal>
        </div >
    );
}

export default CustomSelect;

const RenderCollapsible = ({ categories, activeCategory, setActiveCategory }) => {


    return (
        categories.map((category, index) => {
            return (
                <CollapsibleUI key={index} isMain={true} activeCategory={activeCategory} category={category} setActiveCategory={(category) => { setActiveCategory(category) }}>
                    <RenderCollapsible categories={category.subcategory} activeCategory={activeCategory} setActiveCategory={(cat) => setActiveCategory(cat)} />
                </CollapsibleUI>
            );
        })

    );
}